import {WithSummaryModel} from '../../../../../common/entity/dto/plain/withSummary.model';
import {Scan3dGroupSummaryModel} from './scan3dGroupSummary.model';
import {Scan3dModel} from '../../../common/api/entity/scan3d.model';
import {DocumentSummaryModel} from "../../../../../document/common/api/model/documentSummary.model";

export class Scan3dGroupModel extends WithSummaryModel<Scan3dGroupSummaryModel> {
    scans: Scan3dModel[] = [];
    leftScanDocument: DocumentSummaryModel;
    rightScanDocument: DocumentSummaryModel;
    leftImageDocument: DocumentSummaryModel;
    rightImageDocument: DocumentSummaryModel;
    imageDocument: DocumentSummaryModel;
    scanDocument: DocumentSummaryModel;
}
